import React, { useState } from "react";
import KuikaEntitySwitcher, {
  KuikaEntitySwitcherFolder,
  KuikaEntitySwitcherItem
} from "../../../../ui-kit/kuika-entity-switcher/kuika-entity-switcher";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

const JOBS: KuikaEntitySwitcherItem[] = [
  { id: "nightly-backup", name: "Nightly backup" },
  { id: "invoice-reminders", name: "Invoice reminders" },
  { id: "weekly-report", name: "Weekly report" },
  { id: "cache-warmup", name: "Cache warm-up" },
  { id: "stale-session-cleanup", name: "Stale session cleanup" },
  { id: "sync-crm-contacts", name: "Sync CRM contacts" }
];

const FOLDERS: KuikaEntitySwitcherFolder[] = [
  { id: "billing", name: "Billing", itemIds: ["invoice-reminders", "weekly-report"] },
  { id: "maintenance", name: "Maintenance", itemIds: ["nightly-backup", "cache-warmup", "stale-session-cleanup"] }
];

interface IStatefulProps {
  trigger: "chevron" | "chip";
  withFolders?: boolean;
}

const Stateful: React.FC<IStatefulProps> = ({ trigger, withFolders = false }) => {
  const [currentId, setCurrentId] = useState<string>("weekly-report");
  const current: KuikaEntitySwitcherItem | undefined = JOBS.find(
    (job: KuikaEntitySwitcherItem): boolean => job.id === currentId
  );
  return (
    <KuikaEntitySwitcher
      items={JOBS}
      current={current}
      onSelect={(job: KuikaEntitySwitcherItem): void => setCurrentId(job.id)}
      entityLabel="job"
      iconName="clock"
      trigger={trigger}
      folders={withFolders ? FOLDERS : undefined}
    />
  );
};

export const EntitySwitcherStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Entity Switcher"
      componentName="KuikaEntitySwitcher"
      sourcePath="ui-kit/kuika-entity-switcher"
      description="The editor bars' 'which one' control. Opens the shared picker panel (KuikaEntityPicker): search, folders, the open record behind one sliding fill, and a footer that leads to the full list."
    >
      <SpecRow
        label="Caret trigger"
        caption="trigger=chevron — a 24px square on the sm rung with a 32px hit area; the panel opens on the overlay layer"
      >
        <Stateful trigger="chevron" />
      </SpecRow>
      <SpecRow
        label="Chip trigger"
        caption="trigger=chip — glyph, name and caret; pick another job and reopen: the fill starts on the new one"
      >
        <Stateful trigger="chip" />
      </SpecRow>
      <SpecRow
        label="Folders and filter"
        caption="the fill follows the open record through a filter and hides while the record is filtered out"
      >
        <Stateful trigger="chip" withFolders />
      </SpecRow>
    </ShowcaseFrame>
  );
};
